module.exports = __webpack_public_path__ + "static/img/jzqxtLogoN.4e8f2ac.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/img/jzqxtLogoN.jpg
// module id = MwXw
// module chunks = 2